interface ChatMessage {
    role: 'system' | 'user' | 'assistant';
    content: string;
}

// As chaves NÃO vivem aqui. O cliente fala só com as rotas /api/* do nosso
// backend (server.js em produção, proxy do Vite em dev), que injeta a
// credencial server-side. Nenhum segredo entra no bundle do browser.
const AI_ENGINE = import.meta.env.VITE_AI_ENGINE || 'openai';

async function callOpenAI(messages: ChatMessage[], systemInstruction?: string, jsonMode?: boolean): Promise<string> {
    const formattedMessages = [...messages];
    if (systemInstruction) {
        formattedMessages.unshift({ role: 'system', content: systemInstruction });
    }

    const response = await fetch('/api/openai/v1/chat/completions', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            model: 'gpt-4o-mini',
            messages: formattedMessages,
            response_format: jsonMode ? { type: 'json_object' } : undefined,
            temperature: 0.7
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`OpenAI API error: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    return data.choices[0]?.message?.content || '';
}

async function callAnthropic(messages: ChatMessage[], systemInstruction?: string): Promise<string> {
    // O system prompt é parâmetro top-level na API Anthropic; filtramos os
    // 'system' do histórico de conversa.
    const userAndAssistantMessages = messages.filter(m => m.role !== 'system');

    const response = await fetch('/api/anthropic/v1/messages', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            model: 'claude-sonnet-4-6',
            max_tokens: 4096,
            system: systemInstruction,
            messages: userAndAssistantMessages.map(m => ({
                role: m.role === 'user' ? 'user' : 'assistant',
                content: m.content
            }))
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Anthropic API error: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    return data.content[0]?.text || '';
}

export const llmService = {
    async sendMessage(
        messages: ChatMessage[],
        systemInstruction?: string,
        jsonMode?: boolean
    ): Promise<string> {
        const engine = AI_ENGINE.toLowerCase();

        // Engine primário com fallback automático pro outro provider.
        // Quem tem (ou não) a chave é o backend; o cliente só tenta e,
        // se falhar, cai pro alternativo.
        if (engine === 'claude') {
            try {
                return await callAnthropic(messages, systemInstruction);
            } catch (e) {
                console.warn("Anthropic falhou, tentando OpenAI:", e);
                return await callOpenAI(messages, systemInstruction, jsonMode);
            }
        } else {
            try {
                return await callOpenAI(messages, systemInstruction, jsonMode);
            } catch (e) {
                console.warn("OpenAI falhou, tentando Anthropic:", e);
                return await callAnthropic(messages, systemInstruction);
            }
        }
    }
};
